import { render, staticRenderFns } from "./Prizes2021PromoProduct.vue?vue&type=template&id=19a6bedb&"
import script from "./Prizes2021PromoProduct.vue?vue&type=script&lang=js&"
export * from "./Prizes2021PromoProduct.vue?vue&type=script&lang=js&"
import style0 from "./Prizes2021PromoProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports